import React from "react";
import DateHelpers from '../Helper/DateHelpers.js';
import AddTransaction from '../Routes/AddTransaction.js'
import AccountDetails from "./AccountDetails.js";
import ViewTransactionHistory from '../Components/ViewTransactionHistory.js'
import { useNavigate } from "react-router-dom";
import RegistrationInfo from "./RegistrationInfo.js";
import { useState, useEffect } from "react";
import AdminGroupAccountReservationCardList from "./AdminGroupAccountReservationCardList.js";
import '../Styles/AdminGroupAccountCard.scss';
import { useParams } from "react-router-dom";
import { Link } from "react-router-dom";
import RegistrationDetails from "./RegistrationDetails.js";



function AdminGroupAccountCard({ queriedAccount }) {

   const [queriedReservations, setQueriedReservations] = useState()
   const [reservationsVisibility, setReservationsVisibility] = useState(false)
   const getReservationsForGroupAccount = async () => {
      try {

         // Get Transactions
         var groupAccountId = queriedAccount.group_account_id
         console.log("Group Account ID!", groupAccountId)
         const defaultTransactions = await fetch('/getreservationsbygroupaccount', {
            method: 'POST',
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
               groupAccountId
            })
         })
         var response = await defaultTransactions.json()
         console.log("here's reservations", response)
         setQueriedReservations(response.data.reservations)
      } catch (error) {

      }
   }

   return (
      <div className="AdminGroupAccountCardContainer">
         <div className="AdminGroupAccountCardRowOne">
             <div className="AdminGroupAccountCardRowOneItemHeading">
               {queriedAccount.group_name}
             </div>
             <div className="AdminGroupAccountCardRowOneItem">
               {queriedAccount.group_city+","+ " " + queriedAccount.group_state}
             </div>
             <div className="AdminGroupAccountCardRowOneItem">
               {queriedAccount.group_email}
             </div>
         </div>
         <div className="AdminGroupAccountCardRowTwo">
            <div className="AdminGroupAccountCardRowTwoItem">
               <button onClick={() => {
                  getReservationsForGroupAccount()
                  setReservationsVisibility(!reservationsVisibility)
                  }}>
               View Reservations
               </button>   
            </div>
            <div className="AdminGroupAccountCardRowTwoItem">
               {queriedAccount.group_phone}
             </div>
             <div className="AdminGroupAccountCardRowTwoItem">
               {queriedAccount.church_group_admin}
             </div>
         </div>
         <div className="AdminGroupAccountReservationList">

            {reservationsVisibility && (
            queriedReservations?.length > 0 ? (
              <AdminGroupAccountReservationCardList
               reservations={queriedReservations}/>
            ) : (
               <div>No reservations for this account</div>
            )
         )}
         </div>
      </div>
   )}
   export default AdminGroupAccountCard